

import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeScreen from './HomeScreen';
import HomePage from './HomePage';
import Profile from './Profile';

import ReportIncidentForm from './ReportIncidentForm';
import Auth from './Auth'
import TableView from './TableView'
import IncidentDetail from './IncidentDetail';
import NewHomeScreen from './NewHomeScreen';
import UserProfile from './UserProfile';
import UpdatePassword from './UpdatePassword';
import ForgotPassword from './ForgotPassword';
import MissionStatement from './MissionStatement';
import ModerationDashboard from './ModerationDashboard';
import Confirm from './Confirm';

const App = () => {
    // State to hold the list of incidents
    const [incidents, setIncidents] = useState([]);

    // Callback to add a new incident to the state
    const handleIncidentSubmit = (newIncident) => {
        setIncidents((prev) => [...prev, newIncident]);
    };
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .register("/service-worker.js")
            .then((registration) => {
                console.log("Service Worker registered with scope:", registration.scope);
            })
            .catch((error) => {
                console.error("Service Worker registration failed:", error);
            });
    }

    return (
        <Router>
            <Routes>
                {/* Pass incidents and callback to HomeScreen */}
                {/* <Route
                    path="/"
                    element={<HomeScreen />}
                />

           
                <Route
                    path="/report"
                    element={<ReportIncidentForm onIncidentSubmit={handleIncidentSubmit} />}
                />
               <Route
                    path="/home"
                    element={<NewHomeScreen />}
                /> */}
                
                <Route
                    path="/moderation"
                    element={<ModerationDashboard />}
                />

                <Route
                    path="/"
                    element={<Auth />}
                />
                 {/* <Route
                    path="/table"
                    element={<TableView />}
                />
                 <Route
                    path="/incidentdetail/:id"
                    element={<IncidentDetail />}
                />
                
               <Route
                    path="/incidents"
                    element={<HomePage />}
                />
                 <Route
                    path="/resetpassword"
                    element={<UpdatePassword />}
                />
                <Route
                    path="/forgotpassword"
                    element={<ForgotPassword />}
                />
                <Route
                    path="/user/:username"
                    element={<UserProfile />}
                    />
                    <Route
                    path="/profile"
                    element={<Profile />}
                    />
                <Route
                    path="/about"
                    element={<MissionStatement />}
                    />
                    <Route
                    path="/confirm"
                    element={<Confirm />}
                    /> */}
            </Routes>   
        </Router>
    );
};

export default App;
